import React from 'react';
import ForgotPasswordForm from 'components/ForgotPasswordForm';

function ForgotPassword() {
  return <ForgotPasswordForm />;
}

export default ForgotPassword;
